import {
  mdiClipboardCheckOutline,
  mdiFileDocumentOutline,
  mdiMicrophoneOutline,
} from '@mdi/js';
import type { AssessmentModeOption } from '../types/assessment-mode.types';

export const assessmentModeOptions: AssessmentModeOption[] = [
  {
    id: 'text',
    titleToken: 'app.assessment_mode.selection.text.title',
    descriptionToken: 'app.assessment_mode.selection.text.description',
    enabled: true,
    icon: mdiFileDocumentOutline,
  },
  {
    id: 'guided',
    titleToken: 'app.assessment_mode.selection.guided.title',
    descriptionToken: 'app.assessment_mode.selection.guided.description',
    enabled: true,
    icon: mdiClipboardCheckOutline,
  },
  {
    id: 'voice',
    titleToken: 'app.assessment_mode.selection.voice.title',
    descriptionToken: 'app.assessment_mode.selection.voice.description',
    enabled: true,
    icon: mdiMicrophoneOutline,
  },
];

